module.exports = __webpack_public_path__ + "img/clock_c.f89c500d.svg";